import styled from 'styled-components';

const StyledServicesGridItem = styled.div`
display: flex;
flex-direction: column;
justify-content: center;
text-align: center;
align-items: center;
height: auto;
width: 25%;
color: white;
padding: 5px 20px;

@media only screen and (max-width: 700px) {
width: 80%;
margin: auto;
}
img {
//max-width: 120px;
//height: 120px;
//@media only screen and (max-width: 700px) {
//max-width: 100px;
//height: 100px;
}
.preview-wrapper {
padding: 0.5rem;
border-radius: 50%;
background: #ffbf82;

max-width: 120px;
height: 120px;

display: flex;
align-items: center;
justify-content: center;
transition: background ease-in-out 0.2s;


&:hover {
background: #ff7c02;
}

img {
width: 80%;
height: 80%;
}

@media only screen and (max-width: 700px) {
max-width: 100px;
height: 100px;
}
}
`;

export default StyledServicesGridItem;
